// 配置接口地址
export const api = {
  // 查询研判
  searchVehicleTrail: '/vas/vehicleControl/searchVehicleTrail.json',
  //查询研判新接口
  searchVehicleTrailNew: ' /vas/vehicleSearching/searchVehicleTrail.json',
  // 查询车辆轨迹
  queryCarPoints: '/bas/car/records/points.json',

  // 查询区域树
  querydeviceByArea: '/vas/bayonet/querydeviceByArea.json',
  // querydeviceByArea:'/vas/vehicle/retrieval/querydeviceByArea.json'
  // 车辆研判详情接口
  queryVehicleTrailDetail: '/vas/vehicleSearching/queryVehicleTrailDetail.json'

}

